module.exports = __webpack_public_path__ + "img/md_point.d57905f6.png";